// extracted by mini-css-extract-plugin
export var actionIcon = "_p4-0";